jQuery(document).ready(function( $ ){

	logit = (typeof logit !== 'undefined')? logit : false;

	// cookiebar_enable * - true/false - ON or OFF
	// cookiebar_lang * - en/hr - default: en or pass cookiebar_activate variable
	// cookiebar_activate - cookiebar options array

	var cookiebar_defaults = {
		message: 'We use cookies to track usage and preferences.', //Message displayed on bar
		acceptButton: true, //Set to true to show accept/enable button
		acceptText: 'I Understand', //Text on accept/enable button
		acceptFunction: function(cookieValue){if(cookieValue!='enabled' && cookieValue!='accepted') window.location = window.location.href;}, //Function to run after accept
		acceptClass: 'btn-sm btn-success',
		declineButton: false, //Set to true to show decline/disable button
		declineText: 'Disable Cookies', //Text on decline/disable button
		declineFunction: function(cookieValue){if(cookieValue=='enabled' || cookieValue=='accepted') window.location = window.location.href;}, //Function to run after decline
		declineClass: 'btn-sm btn-danger',
		policyButton: false, //Set to true to show Privacy Policy button
		policyText: 'Privacy Policy', //Text on Privacy Policy button
		policyURL: '/privacy-policy/', //URL of Privacy Policy
		policyClass: 'btn-sm',
		showMore:true, // Add more options dropdown
		showMoreMarketing:true, // More options text
		showMoreAnalytics:true, // More options text
		showMoreAnalyticsCheched:true, // Precheck analytics
		showMoreClass: '',
		showMoreHidden: 'd-none',
		showMoreHiddenClass: '',
		acceptFunctionMarketing: function(cookieValueM){if(cookieValueM =='accepted') console.log('enabled marketing cookies');}, //Function to run after accept
		acceptFunctionAnalytics: function(cookieValueA){if(cookieValueA =='accepted') console.log('enabled analytics cookies');}, //Function to run after accept
		showMoreText:'more', // More options text
		showMoreInfo:'', // More options text
		showMorePrimaryText:'Only Neccesary', // More options text
		showMoreAnalyticsText:'Analytics', // More options text
		showMoreMarketingText:'Marketing', // More options text
		autoEnable: true, //Set to true for cookies to be accepted automatically. Banner still shows
		acceptOnContinue: false, //Set to true to accept cookies when visitor moves to another page
		acceptOnScroll: false, //Set to true to accept cookies when visitor scrolls X pixels up or down
		acceptAnyClick: false, //Set to true to accept cookies when visitor clicks anywhere on the page
		expireDays: 365, //Number of days for cookieBar cookie to be stored for
		renewOnVisit: false, //Renew the cookie upon revisit to website
		forceShow: false, //Force cookieBar to show regardless of user cookie preference
		forceShowHash: '#edit-cookies',
		effect: 'slide', //Options: slide, fade, hide
		element: 'body', //Element to append/prepend cookieBar to. Remember "." for class or "#" for id.
		append: false, //Set to true for cookieBar HTML to be placed at base of website. Actual position may change according to CSS
		fixed: true, //Set to true to add the class "fixed" to the cookie bar. Default CSS should fix the position
		position: 'bottom', //Add class to position cookiebar, bottom etc...
		zindex: '1000', //Can be set in CSS, although some may prefer to set here
		domain: String(window.location.hostname), //Location of privacy policy
		referrer: String(document.referrer), //Where visitor has come from
            };

	// AUTOLOCALISE
	cookiebar_lang = (typeof cookiebar_lang !== 'undefined')? cookiebar_lang : 'en';

	if (cookiebar_lang == 'hr') {
		cookiebar_defaults.message = '<i class="fa fa-exclamation-circle"></i> Koristimo kolačiće kako bi vaše iskustvo na našem webu bilo što bolje.';
		cookiebar_defaults.acceptText = '<i class="fa fa-check"></i> Prihvati';
		cookiebar_defaults.declineText = '<i class="fa fa-user-secret"></i> Blokiraj';
		cookiebar_defaults.policyText = '<i class="fa fa-info-circle"></i> Vaša privatnost';
		cookiebar_defaults.showMoreText = 'više'; // More options text
		cookiebar_defaults.showMoreInfo = ''; // More options text
		cookiebar_defaults.showMorePrimaryText ='Samo nužno'; // More options text
		cookiebar_defaults.showMoreAnalyticsText = 'Analytics'; // More options text
		cookiebar_defaults.showMoreMarketingText = 'Marketing'; // More options text
		cookiebar_defaults.policyURL = '/privacy/#cookie';
		}


	// COOKIE BAR
	cookiebar_enable = (typeof cookiebar_enable !== 'undefined')? cookiebar_enable : true;
	cookiebar_activate = (typeof cookiebar_activate !== 'undefined')? cookiebar_activate : cookiebar_defaults;
	cookiebar_forceShow = (typeof cookiebar_forceShow !== 'undefined')? cookiebar_forceShow : false;

	if(cookiebar_forceShow) {
		cookiebar_activate.forceShow = cookiebar_forceShow;
		if(logit == 2) console.log('[COOKIEBAR] Force show');
	}

	if(cookiebar_activate && cookiebar_enable || cookiebar_forceShow) {

		if(logit) console.log('[COOKIEBAR] Started');

		// START COOKIE BAR
		$.cookieBar(cookiebar_activate);

		//ANALYTICS DATA
		if(jQuery.cookieBar('cookies')){
			// RUN On accept nessesary
			if(logit == 2) console.log('[COOKIEBAR] Accepted');
		}
		if(jQuery.cookieBar('analytics')){
			// RUN On accept analytics
			if(logit == 2) console.log('[COOKIEBAR] Accepted Analytics');
		}
		if(jQuery.cookieBar('marketing')){
			// RUN On accept marketing
			if(logit == 2) console.log('[COOKIEBAR] Accepted Marketing');
		}
	}

	// END JQUERY
});
